function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import React from "react";
import { setPath } from "./objectPath";
import { DEFAULT_BREAKPOINT } from "./css";
export function getStickyItemInfo(children, theme) {
  var childrenArray = React.Children.toArray(children);

  if (childrenArray.length === 0) {
    throw new Error("Sticky.Item cannot be empty.");
  }

  if (childrenArray.length > 1) {
    throw new Error("Sticky.Item must have a single child.");
  }

  var component = childrenArray[0].type;
  var id = component.ID;

  if (!id || typeof id !== "string") {
    throw new Error('Sticky.Item\'s child must expose a unique ID, e.g.: MyChild.ID = "MyChild";');
  }

  var componentHeightMap = component.HEIGHT_MAP;

  if (!componentHeightMap || _typeof(componentHeightMap) !== "object") {
    throw new Error("Sticky.Item's child must expose a HEIGHT_MAP object.");
  }

  if (typeof componentHeightMap[DEFAULT_BREAKPOINT] === "undefined") {
    throw new Error("Sticky.Item's child exposes a HEIGHT_MAP object, but the object is missing a `".concat(DEFAULT_BREAKPOINT, "` property."));
  }

  var height = componentHeightMap[DEFAULT_BREAKPOINT];

  if (typeof height !== "number" || height <= 0) {
    throw new Error("Sticky.Item's child exposes a HEIGHT_MAP object, but object's `".concat(DEFAULT_BREAKPOINT, "` value is not a positive integer."));
  }

  var heightMap = _defineProperty({}, DEFAULT_BREAKPOINT, height);

  var lastHeight = height;

  for (var bp in theme.breakpoints) {
    height = componentHeightMap[bp];

    if (typeof height === "undefined") {
      heightMap[bp] = lastHeight;
    } else if (typeof height === "number" && height > 0) {
      heightMap[bp] = height;
      lastHeight = height;
    } else {
      throw new Error("Sticky.Item's child exposes a HEIGHT_MAP object, but object's `".concat(bp, "` value is not a positive integer."));
    }
  }

  return {
    id: id,
    heightMap: heightMap
  };
}
export function getStickyItemCSS(_ref) {
  var heightMap = _ref.heightMap,
      offsetMap = _ref.offsetMap,
      theme = _ref.theme;
  var result = {
    /*
      We want to ensure that Sticky.Items are painted above normal content.
      Is normal content has `position: relative` (like Grid does), it would be 
      painted on top of the Sticky.Item if the Sticky.Item doesn't have z-index > 0.
      That's why we define a z-index on Sticky.Items.
      See: https://stackoverflow.com/q/60825826/247243
    */
    zIndex: theme.zIndices.stickyItem,
    position: "sticky"
  };
  var lastHeight = null;
  var lastOffset = null;

  for (var bp in heightMap) {
    if (heightMap[bp] !== lastHeight) {
      lastHeight = heightMap[bp];
      var height = "".concat(lastHeight, "px");
      result = setPath(result, bp === DEFAULT_BREAKPOINT ? "height" : "".concat(theme.minMediaQueries[bp], ".height"), height);
    }

    if (offsetMap[bp] !== lastOffset) {
      lastOffset = offsetMap[bp];
      var top = "".concat(lastOffset, "px");
      result = setPath(result, bp === DEFAULT_BREAKPOINT ? "top" : "".concat(theme.minMediaQueries[bp], ".top"), top);
    }
  }

  return result;
}